import { MATERIAL_TYPE_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IMaterialType } from "../../shared/interfaces/material-type/IMaterialType";

export const MaterialTypeService = {
  getAll: (params: IPagination) => requests.get(MATERIAL_TYPE_URL, params),
  create: (params: IMaterialType) => requests.post(`${MATERIAL_TYPE_URL}`, params),
  getSingle: (id: number) => requests.get(`${MATERIAL_TYPE_URL}/${id}`),
  update: (params: IMaterialType, id: number) =>
    requests.put(`${MATERIAL_TYPE_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${MATERIAL_TYPE_URL}/${id}`),
  sort: (ids: number[]) => requests.patch(`${MATERIAL_TYPE_URL}/sort`, { ids }),
};
